<template>
  <base-message :message="message">
    <div class="message-body text-message">
      <div v-html="typingText" v-show="text"></div>
    </div>
  </base-message>
</template>

<script>
// import LoadingDot from './LoadingDot'
import BaseMessage from './BaseMessage'
import IClassroom from '@/components/classroom/lib/IClassroom'

export default {
  components: { BaseMessage },
  data () {
    return {
      tipsContent: '',
      showTips: false,
      typingText: ''
    }
  },
  computed: {
    text () {
      if (this.message.data.text) {
        let text = this.message.data.text
        text = text.replace(/{\s*name\s*}/g, IClassroom.user.name)
        return text
      }
      return ''
    }
  },
  mounted () {
    IClassroom.saySomething(this.text)
    this.typingText = this.text
  },
  props: ['message'],
  methods: {
    typing () {
      if (this.typingText.length < this.text.length) {
        this.typingText += this.text[this.typingText.length]
      } else {
        return
      }
      window.requestAnimationFrame(this.typing)
    }
  }
}
</script>

<style lang="stylus" scoped>
.text-message {
  max-width 800px
}
</style>
